module.exports = __webpack_public_path__ + "img/skyward-pride.ee37939f.webp";